import { Fragment } from 'react'
import { EmptyResult } from './pages/styles'
import { ReactComponent as EmptyResultIcon } from 'assets/images/icons/empty-result.svg'

export function EmptyResultComponent() {
  return (
    <Fragment>
      <EmptyResult className='d-flex'>
        <div className='emptyIcon'>
          <EmptyResultIcon />
          <h5>Sorry, No Result...</h5>
        </div>
      </EmptyResult>
    </Fragment>
  )
}
